<header class="content-header">
    <a class="btn btn-outline-primary" [routerLink]="['/portfolio/add'] | localize" target="_blank">
        <i class="fi fi-rs-plus"></i>
        {{'portfolio_btnAdd' | translate}}
    </a>
</header>

<app-table [columns]="columns" [rows]="rows">
    <ng-template #rowTemplate let-row>
        <tr>
            <td>{{row.Title}}</td>
            <td>{{row.Added | appDate:'datetime'}}</td>
            <td>
                <div class="table-actions">
                    <a target="_blank"
                            class="btn btn-outline btn-icon"
                            [ngbTooltip]="'open' | translate"
                            [routerLink]="['/portfolio', row.Id] | localize">
                        <i class="fi fi-rs-angle-right"></i>
                    </a>
                </div>
            </td>
        </tr>
    </ng-template>
</app-table>

